import PropTypes from "prop-types";
import { formatFirestoreTimeStamp } from "utils";
import Text from "../Text";

import "./styles.css";

function GameHeader({ holeNumber, holePar, hdcp, createdUtc }) {
  return (
    <div className="game-header--wrapper">
      <div>
        <Text as="C1" bold style={{ color: "#CCE6F6" }}>
          {formatFirestoreTimeStamp(createdUtc, "hh:mm a")}
        </Text>
        <Text as="H1" bold>
          Hole {holeNumber + 1}
        </Text>
      </div>
      <div className="game-header--tags-wrapper">
        <div className="game-header--tag-par">
          <Text as="C1" bold style={{ color: "#1B4F6D" }}>
            PAR {holePar}
          </Text>
        </div>
        <div className="game-header--tag-dhcp">
          <Text as="C1" bold style={{ color: "#1B4F6D" }}>
            HCP {hdcp}
          </Text>
        </div>
      </div>
    </div>
  );
}

GameHeader.propTypes = {
  hdcp: PropTypes.number,
  holeNumber: PropTypes.number.isRequired,
  holePar: PropTypes.number.isRequired,
  createdUtc: PropTypes.string.isRequired,
};

GameHeader.defaultProps = {
  hdcp: 0,
};

export { GameHeader };
